// External
import { Component, Input, Output, EventEmitter } from '@angular/core';

// Internal

@Component({
    selector: 'ui-drawer',
    template: '<ng-content></ng-content> <div class="drawer-backdrop" *ngIf="this.hasBackdrop" (click)="closeDrawer()"></div>',
    host: {
      '[class.drawer-viewport]': 'true',
      '[class.displace]': 'this.displace'
    }
})

export class UiDrawerComponent {

    @Input() displace: boolean = false;
    @Input() hasBackdrop: boolean = false;
    @Output() backdropAction: EventEmitter<string> = new EventEmitter();

    closeDrawer() {
        this.backdropAction.emit();
    }
}
